
// Start Update Save Based Under Appstel Based on Variant Selection //
function getSelectedVariantData() {
  const checked = document.querySelector('.simple-variant-picker__radio:checked');
  if (!checked) return null;
  const container = checked.closest('.simple-variant-picker__value-container');
  if (!container) return null;
  const discount = container.querySelector('.discounted_price')?.textContent.trim();
  const comparePrice = container.querySelector('.varinat_price s')?.textContent
    .replace(/[()]/g, '')  // remove brackets if like ($89.99)
    .trim();
  return { discount, comparePrice };
}

function updateAppstleUI() {
  const data = getSelectedVariantData();
  if (!data) return;
  //  Update SAVE badge
  const badge = document.querySelector('.appstle-save-badge');
  if (badge && data.discount && badge.textContent.replace('SAVE', '').trim() !== data.discount.replace('SAVE', '').trim()) {
    badge.textContent = data.discount.replace('SAVE', '').trim();
  }
  //  Update Compare Price
  const compareEl = document.querySelector('.appstle_subscription_compare_amount');
  if (compareEl && data.comparePrice && compareEl.textContent !== data.comparePrice) {
    compareEl.textContent = data.comparePrice;
  }
}
// Observe Appstle re-render
const observer = new MutationObserver(() => {
  updateAppstleUI();
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});
// Update on variant change
document.addEventListener('change', function(e) {
  if (e.target.matches('.simple-variant-picker__radio')) {
    updateAppstleUI();
  }
});

// Initial sync
updateAppstleUI();
// End Update Save Based Under Appstel Based on Variant Selection //

// Start Variant Price Change Based on Subscription/One-time Purchase //
function checkSellingPlan() {
  const url = new URL(location.href);
  const params = new URLSearchParams(url.search);
  const oneTimePrices = document.querySelectorAll('.one_time_price');
  const subscriptionPrices = document.querySelectorAll('.subscription_price');
  if (params.has('selling_plan')) {
    oneTimePrices.forEach(el => el.style.display = 'none');
    subscriptionPrices.forEach(el => el.style.display = 'block');
  } else {
    oneTimePrices.forEach(el => el.style.display = 'block');
    subscriptionPrices.forEach(el => el.style.display = 'none');
  }
}
checkSellingPlan();
(function(history){
  const pushState = history.pushState;
  const replaceState = history.replaceState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(checkSellingPlan, 50);
  };
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    setTimeout(checkSellingPlan, 50);
  };
})(window.history);
// detect back/forward
window.addEventListener('popstate', checkSellingPlan);
// End Variant Price Change Based on Subscription/One-time Purchase //

// code starting price update under add to cart button //

function getSelectedPrice() {
 
   const url         = new URL(location.href);
   const params      = new URLSearchParams(url.search);
   const variantId   = params.get('variant');
    
   const sellingPlanId = params.get('selling_plan');
   const selectedVariant = productVariants.find(v => v.id == variantId);
   let price = selectedVariant.price;
   let comparePrice = selectedVariant.compare_at_price;
   if (sellingPlanId) {
    const selectedPlan = selectedVariant.selling_plans.find(p => p.id == sellingPlanId);

    if (selectedPlan) {
      price = selectedPlan.price;
    }
   }

  // console.log('selectedVariant:', selectedVariant);
  // console.log("Variant ID:", variantId);
  // console.log("Selling Plan:", sellingPlanId || "None");
  // console.log("Price:", price);
  // console.log("Compare At Price:", comparePrice);
  const buttonText = document.querySelector('.product-form__submit .button-text');
  if(buttonText){
    buttonText.innerHTML = `ORDER NOW - ${price} <span class="compare-price">(${comparePrice})</span>`;
  }
}
setTimeout(getSelectedPrice, 4000);
(function(history){
  const pushState = history.pushState;
  const replaceState = history.replaceState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(getSelectedPrice, 2000);
  };
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    setTimeout(getSelectedPrice, 2000);
  };
})(window.history);
// detect back/forward
window.addEventListener('popstate', getSelectedPrice);

// code Ending price update under add to cart button //
